import { RecordDataSource } from "../../../../records/grids";
import { moneyValueGetterFactory } from "../../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";

import { vsObjectName as gamingContractName } from "./gamingContract";

GamingContractLineItemConfig.$inject = [RecordGridViewServiceProviderName];

export const vsObjectName = "gamingContractLineItem";

const url = "/api/contract/gamingContract/lineItem";

export function GamingContractLineItemConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureGrid(recordGridViewServiceProvider);
}

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    GridSettingsServiceName,
    (
      recordGridViewService: RecordGridViewService,
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      const gamingContractConfig =
        recordGridViewService.getGridConfiguration(gamingContractName);
      if (gamingContractConfig === undefined) {
        throw new Error("Couldn't find gamingContract config");
      }
      return {
        defaultSort: `${gamingContractConfig.defaultSort ?? ""},Order`,
        gridDataSource: new RecordDataSource(serverUtility, url),
        nameSingular: "Cost",
        namePlural: "Costs",
        gridSettings: gridSettingsService.getGridSettings(
          Symbol("contract.type.gamingcontract.lineItem")
        ),
        showAddButton: false,
        columns: [
          columnDefinitionService.getIdColDef(),
          columnDefinitionService.getStringColDef({
            field: "Description",
            header: "Line Item Description",
          }),
          columnDefinitionService.getStringColDef({
            header: "Cost Type",
            field: "GamingContractCostTypeName",
          }),
          columnDefinitionService.getNumberColDef({
            field: "Quantity",
          }),
          columnDefinitionService.getNumberColDef({
            field: "UnitPrice",
            header: "Unit Price",
            valueGetter: moneyValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "Total",
            valueGetter: moneyValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "NetTotal",
            header: "Net Total",
            valueGetter: moneyValueGetterFactory(),
          }),
          columnDefinitionService.getNumberColDef({
            field: "Discount",
            valueGetter: moneyValueGetterFactory(),
          }),
          ...(gamingContractConfig.columns ?? []),
        ],
      };
    },
  ]);
}
